module.exports = __webpack_public_path__ + "static/media/face.ec528b0f.svg";